// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { AxiosBFFResponse, FailureBFFResponse } from '@/@types/common';
import { showErrorModal } from '@/utils/error';
import { AxiosInstance } from 'axios';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace GraphqlRequestService {
  class _GraphqlRequestService {
    private axiosInstance: AxiosInstance | undefined;

    setAxiosInstance(axiosInstance: AxiosInstance) {
      this.axiosInstance = axiosInstance;
    }

    async request<T>(
      query: string,
      variables?: { [key: string]: any },
      headers?: { [key: string]: string }
    ): Promise<T | undefined> {
      if (this.axiosInstance === undefined) {
        throw new Error('axiosInstance 가 초기화되지 않음.');
      }

      const graphqlQuery = {
        query: query,
        variables: variables
      };

      return await this.axiosInstance
        .post('', graphqlQuery, {
          headers: {
            'Content-Type': 'application/json',
            ...headers
          }
        })
        .then((response: AxiosBFFResponse<T, null>) => {
          if (!response.data.success) throw response.data;
          return response?.data.result.data;
        })
        .catch((error: FailureBFFResponse<null>) => {
          showErrorModal(error.code);

          throw error.message;
        });
    }
  }

  export const instance: _GraphqlRequestService = new _GraphqlRequestService();
}
